module.exports = "images/apple-icon-180x180.78fafec446255aadaf1040cbb16a928f.png";